<script lang="ts">
import { TransformerService } from '../services/transformer.service'

export default {
    data() {
        return {
            geojson: null,
            loading: false,
            loadingMap: false,
            loadingMapUrl: "",
            filters: null,
            lastPage: 1,
            total: null,
            meta: null,
            sort: { ...this.initSort },
            sortable: [],
            exportable: [],
            data: [],
            loadingQuery: {},
            createData: {},

            previousFiltersQuery: [], // TO RELAUNCH MAP FETCH IF FILTERS QUERY ARE DIFFERENT
        }
    },
    computed: {
        hasPermissionOnTable() {
            const permission = `${this.permissionName}_index`
            return this.$permissionCheck(permission)
        },
    },
    mounted() {
        const permission = `${this.permissionName}_page`
        if (!this.$permissionCheck(permission)) {
            console.warn(`Permission needed: ${permission}`)
            this.$showToaster({ text: 'Vous n\'avez pas les droits suffisants pour accéder à cet espace.', color: 'error', icon: 'mdi-information' })
            this.$router.replace('/')
        }
        this.preLoadDataMeta()
        this.checkFiltersParams()
    },
    methods: {
        checkFiltersParams() {
            this.loadingQuery = this.$route?.query
        },
        preLoadDataMeta() {
            this.loading = true
            if (this.hasPermissionOnTable) {
                this.$api.getListData({
                    url: this.requestName,
                    translation: this.translationName,
                    pagination: { number: 1, size: 1 },
                }).then((res) => {
                    this.meta = res.meta
                    this.filters = res.meta.allowed_filters

                    // IF NO DEFAULT FILTER -> RELOAD DATA / ELSE FILTERS WATCH WILL RELOAD DATA
                    if (!this.filters.find(filter => filter.initial_value)) {
                        // IF NO URL FILTERS - IF AN APP USE URL QUERY FOR ANOTHER REASON, TABLE WONT LOAD
                        const urlQueryKeyList = Object.keys(this.$route.query)
                        /*const hasUrlQuery = urlQueryKeyList.length*/

                        // refs.filters not yet initialized, so always pass the condition : this.$refs.filters && !hasUrlQuery
                        // S'il y a au moins un pre-filtre dans urlQuery et qui est disponible dans this.filters, il faut ne pas lancer loadData() car il sera automatiquement lancer par les filtres.

                        const filtersNameEnabled = this.filters.map( f => f.name)
                        let foundMatchQueryAndFilter = false
                        urlQueryKeyList.forEach( urlKey => {
                            foundMatchQueryAndFilter = !!filtersNameEnabled.find(filterName => urlKey === filterName)
                        })

                        if ((!this.$refs.filters && !foundMatchQueryAndFilter) || !foundMatchQueryAndFilter) {
                            this.loadData()
                        }
                    }
                }).catch(() => {
                    throw createError({
                        statusCode: 404,
                        fatal: true,
                        statusMessage: 'Page Not Found',
                    })
                })
            }
        },
        loadData() {
            if (this.hasPermissionOnTable) { // KEEP PERMISSION CHECK HERE FOR RELOADS
                const filterQuery = this.$refs.filters?.getQuery() || null
                const paginationQuery = this.customPaginationQuery || this.$refs.pagination?.getQuery() || null
                const sort = this.$refs.table?.sort || null
                this.loading = true
                this.$api.getListData({
                    url: this.requestName,
                    query: filterQuery,
                    translation: this.translationName,
                    pagination: paginationQuery,
                    sort,
                }).then((res) => {
                    this.data = res.data
                    this.meta = res.meta
                    this.filters = res.meta.allowed_filters
                    this.sortable = res.meta.allowed_sorts
                    this.exportable = res.meta.available_exports
                    this.lastPage = res.meta.last_page
                    this.total = res.meta.total
                    // this.sort = res.meta.request.sort

                    // RESET SELECTED DATA FROM TABLE IF EXIST
                    if (this.$refs.table) {
                        this.$refs.table.resetSelectedData()
                    }

                    this.loading = false
                }).catch(() => {
                    throw createError({
                        statusCode: 404,
                        fatal: true,
                        statusMessage: 'Page Not Found',
                    })
                })
                if (this.hasMap) {
                    if (this.previousFiltersQuery !== filterQuery) {
                        this.previousFiltersQuery = { ...filterQuery }
                        this.loadMapData()
                    }
                }
            }
            else {
                console.error(`Permission needed: ${permission}`)
            }
        },
        loadMapData() {
            // const filterQuery = this.$refs?.filters ? this.$refs.filters.query : ""
            const filterQuery = this.$refs.filters?.getQuery() || null

            const route = {
                url: `${this.requestName}?format=geojson`,
                query: filterQuery,
                method: 'GET',
            }
            if (this.loadingMap && this.loadingMapUrl !== this.$api.formatUrl(route)) {
                // CANCEL PREVIOUS GEOJSON REQUEST
                this.$api.abortsControllers[this.loadingMapUrl].abort('GeoJSON with different filters is being loaded.')
                this.$api.deleteAbortController(this.loadingMapUrl)
            }

            this.loadingMap = true
            // ASSUMING THERE IS ONLY ONE MAP LOADING
            this.loadingMapUrl = this.$api.formatUrl(route)
            this.$api.setRequest(route, true)
            .then((res) => {
                this.geojson = res
                this.loadingMap = false
            })
            .catch( err => {
                console.warn('err', err)
                // this.loadingMap = false
            })
        },
        getCreateRequest() { // FOR SPECIAL CREATE
            const keys = Object.keys(this.createData)
            let query = ''
            keys.forEach((key, i) => {
                query += i === 0 ? '?' : '&'
                query += `${key}=${this.createData[key]}`
            })
            return `${this.defaultUrl}/nouveau/formulaire${query}`
        },
        async deleteData(item) {
            if (item.k) {
                await this.$api.setRequest({
                    url: `${this.requestName}/${item.k}`,
                    method: 'DELETE',
                    translation: this.translationName,
                    body: item,
                })
                this.loadData()
            }
        },
        async restoreData(item) {
            if (item.k) {
                if (confirm(`Souhaitez-vous restaurer cet élément ?`)) {
                    await this.$api.setRequest({
                        url: `${this.requestName}/${item.k}/restore`,
                        method: 'PUT',
                        translation: this.translationName,
                        body: item,
                    })
                    this.loadData()
                }
            }
        },
        // Map TEMPLATE METHODS to Transform service
        isChips(key, value, template) {
            return (new TransformerService()).isChips(key, value, template, this.translationName)
        },
        isMultipleChips(key, value, template) {
            return (new TransformerService()).isMultipleChips(key, value, template, this.translationName)
        },
        toTranslate(key, value) {
            return (new TransformerService()).toTranslate(key, value, this.translationName)
        },
        hasUrlProperty(key, value) {
            return (new TransformerService()).hasUrlProperty(key, value)
        },
        isDate(key, value) {
            return (new TransformerService()).isDate(key, value)
        },
        isDateTime(key, value) {
            return (new TransformerService()).isDateTime(key, value)
        },
        isNumericDate(key, value) {
            return (new TransformerService()).isNumericDate(key, value)
        },
        isBold(key, value) {
            return (new TransformerService()).isBold(key, value)
        },
        isBoolean(key, value) {
            return (new TransformerService()).isBoolean(key, value)
        },
        clearTags(key, value) {
            return (new TransformerService()).clearTags(key, value)
        },
        isCroppedField(key, value: string, length = 100) {
            return (new TransformerService()).isCroppedField(key, value, length)
        },
        isCroppedWithTooltip(key, value, template, length = 100) {
            return (new TransformerService()).isCroppedWithTooltip(key, value, template, length)
        },
        textLeft(key, value, template) {
            return (new TransformerService()).textLeft(key, value, template)
        },
        // -------------------------

    },
    watch : {

    }
}
</script>
